import React, { useMemo, useCallback } from 'react';
import { Page, PageHeader } from '@tanium/react-page';
import { useAuthContext } from '../../auth';
import { getArtifactsLink } from '../../utilities/instanceHelper';
import { useTokenReloaderEffect } from '../../auth/useTokenReloaderCallbacks';
import { AmpAccessToken } from '../../auth/Auth';
import { IframeContainer } from '../CloudManagement/CMP';
import { useIframeMessageHandler } from '../../hooks/useIframeMessageHandler';

export const Artifacts: React.VFC = () => {
  const auth = useAuthContext();
  const [iframeLoaded, setIframeLoaded] = React.useState(false);
  const [authToken, setAuthToken] = React.useState<string>();

  const artifactsUrl = useMemo(() => {
    if (window.location.host.startsWith('localhost')) {
      return 'http://localhost:3000/#/';
    }

    return getArtifactsLink();
  }, []);

  // TODO(TSP-1788): Remove when artifacts is explicitly requesting token
  const tokenCallback = useCallback(
    (token: AmpAccessToken) => {
      if (!iframeLoaded) {
        return false;
      }
      const iframe = document.querySelector('iframe');
      const handle = iframe!.contentWindow;

      // NOTE, the following is a hack, where the content security policy will block
      // AMP from checking the origin once the iframe content has loaded.
      // postMessage is asynchronous and cannot catch an error, so this gives a
      // quick way to ensure that the iframe is actually loaded.
      try {
        handle!.origin;
      } catch {
        // no-op
      }

      const message = {
        jwt: token.token,
      };
      let times = 0;
      const intervalId = setInterval(() => {
        handle!.postMessage(message, artifactsUrl);
        times++;
        // 20 times per second for 10 seconds
        if (times >= 20 * 10) {
          clearInterval(intervalId);
        }
      }, 50);
      if (token.token !== authToken) {
        setAuthToken(token.token);
      }
      return true;
    },
    [artifactsUrl, authToken, iframeLoaded]
  );

  useTokenReloaderEffect(auth, tokenCallback);
  useIframeMessageHandler(artifactsUrl, authToken);

  return (
    <IframeContainer>
      <Page header={<PageHeader heading={''} />}>
        <iframe
          id="artifactsIframe"
          data-testid="artifactsIframe"
          title="Artifacts"
          src={artifactsUrl}
          width="100%"
          style={{
            height: 'calc(100% + 300px)',
            border: 'none',
          }}
          onLoad={() => {
            setIframeLoaded(true);
          }}
        />
      </Page>
    </IframeContainer>
  );
};
